var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 361,
    viewBox: "0 0 161 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.0934 74.7565C116.819 74.7565 141.187 69.0017 152.233 87.0769C156.233 93.6225 158.455 98.5391 158.455 106.117C158.455 114.307 160.278 125.03 156.651 132.563C146.296 154.068 129.256 171.352 118.134 192.36C115.487 197.361 114.828 202.064 112.783 206.921C111.661 209.584 109.174 216.545 109.174 219.241",
    stroke: "#1D3515",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.174 220.361C106.093 228.256 101.682 231.005 93.991 233.801C88.0003 235.98 79.3011 243.432 75.5726 248.611C70.4439 255.734 63.2434 261.731 59.8299 270.265C55.0808 282.138 49.7551 293.392 46.3895 305.733C44.3016 313.388 40.8021 320.117 39.607 327.884C38.7046 333.75 36.8508 339.443 35.5003 345.183C34.4655 349.58 36.4741 354.745 35.0025 358.996C34.1919 361.338 29.0451 349.155 28.5311 347.485C24.8689 335.583 20.9887 323.891 17.3308 311.955C13.7421 300.245 5.86101 287.967 5.01041 275.492C4.62026 269.769 1.86279 264.143 1.6503 258.193C1.50109 254.015 1.6503 249.806 1.6503 245.624C1.6503 236.502 6.37054 227.091 12.3529 220.361C14.6797 217.743 16.281 213.388 18.6997 210.53C20.8651 207.97 23.9245 206.371 25.7311 203.56C27.3246 201.082 30.5329 198.57 30.7712 195.471C31.2362 189.427 31.8913 183.601 31.8913 177.364C31.8913 169.931 28.3291 163.594 25.7311 156.955C23.0849 150.192 22.9953 142.723 21.562 135.736C19.1724 124.087 17.3308 111.345 17.3308 99.3972C17.3308 95.0066 16.9559 91.4562 19.0108 87.5746C22.5506 80.8885 30.8656 75.1159 37.4914 71.6452C41.3703 69.6134 53.2377 69.2878 55.412 73.6364",
    stroke: "#1D3515",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0519 224.841C45.6875 231.061 36.1711 237.221 33.8824 246.122C32.0451 253.267 30.892 260.393 29.7134 267.465C27.9347 278.137 28.5311 289.289 28.5311 300.132C28.5311 310.141 30.7712 319.56 30.7712 329.502C30.7712 337.586 33.0113 344.959 33.0113 352.525",
    stroke: "#1D3515",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.055 106.117C136.055 122.515 135.841 134.818 126.596 148.928C123.743 153.283 120.375 159.036 118.258 163.799C117.211 166.156 116.222 172.833 114.214 174.44C110.882 177.105 110.294 187.663 110.294 191.8C110.294 193.217 110.048 194.894 110.356 196.28C110.838 198.45 114.988 201.66 112.907 202.44C110.339 203.404 106.836 201.124 105.814 199.08",
    stroke: "#1D3515",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.333 196.84C105.311 199.945 110.08 202.226 113.654 205.801",
    stroke: "#1D3515",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.213 196.84C97.881 208.794 98.4965 215.022 109.174 220.361",
    stroke: "#1D3515",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74C62.481 82.36 70.4794 84 81.359 84C86.1844 84 87.8186 82.4209 92.1396 80.9136C95 79 97 77.5 98.5 74.5",
    stroke: "#1D3515",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9995 72C46.5618 79.2998 55.5269 90.4604 62.9995 94C71.0934 97.834 83.8386 100.517 92.9954 100.517C96.8247 100.517 100.656 100.769 104.134 98.8372C108.438 96.4459 109.748 93.5708 112.534 90.437C114.343 88.4019 119.999 77.2324 119.999 75",
    stroke: "#1D3515",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88C55.4335 107.673 60 124.412 60 144",
    stroke: "#1D3515",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0007 71C41.0007 78.6536 44.2116 91.1836 44.2116 98.8372C44.2116 105.425 46.4517 111.83 46.4517 118.438C46.4517 124.225 46.4517 130.011 46.4517 135.798C46.4517 142.908 53.2984 144 60.0007 144",
    stroke: "#1D3515",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4996 115C50.7471 114.171 53.3824 113.958 57.6521 113.958",
    stroke: "#782A2A",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4517 118.438H57.652",
    stroke: "white",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47 123L57.6524 122.918",
    stroke: "#1D3515",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 37C107.5 56.9409 94.6648 72.5 79.5 72.5C64.3352 72.5 51.5 56.9409 51.5 37C51.5 17.0591 64.3352 1.5 79.5 1.5C94.6648 1.5 107.5 17.0591 107.5 37Z",
    stroke: "black",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson2);
export default __webpack_public_path__ + "static/media/person-2.4eefa4232a27f45b432622132aa0f886.svg";
export { ForwardRef as ReactComponent };